export const navLinksdata = [
  {
    _id: 1001,
    title: "Home",
    link: "home",
  },
  {
    _id: 1002,
    title: "About",
    link: "about",
  },
  {
    _id: 1003,
    title: "Achievements",
    link: "achievements",
  },
  {
    _id: 1004,
    title: "Services",
    link: "features",
  },
  {
    _id: 1005,
    title: "Projects",
    link: "projects",
  },
  {
    _id: 1006,
    title: "Resume",
    link: "resume",
  },
  {
    _id: 1007,
    title: "Competitions",
    link: "competitions",
  },
  {
    _id: 1008,
    title: "Testimonial",
    link: "testimonial",
  },
  {
    _id: 1009,
    title: "Contact",
    link: "contact",
  },
];
